var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-2 text-center"},[_c('b-spinner'),_c('div',{staticClass:"mt-1"},[_c('small',{domProps:{"textContent":_vm._s(_vm.$t('common.loading'))}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }